import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { FeatureGate } from './FeatureGate'

export function FeatureRoute({
  children,
  enabled,
  fallbackTo = '/',
}: {
  children: ReactNode
  enabled: boolean
  fallbackTo?: string
}) {
  return (
    <FeatureGate enabled={enabled} fallback={<Navigate to={fallbackTo} replace />}>
      {children}
    </FeatureGate>
  )
}
